// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/App.css */
.App {
  text-align: center;
}

.top-bar {
  position: fixed;
  top: 0;
  z-index: 1000;
  width: 100%;
  background-color: #282c34;
  padding: 10px 20px;
  color: white;
  justify-content: start;
  align-items: left;
  display: flex;
  gap: 10px;
}

.menu button {
  margin-right: 20px;
  background-color: #61dafb;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 1rem;
}

.content {
  background-color: #393e48;
  padding: 80px;
}

.chart-container {
  max-height: calc(100vh - 60px); /* Adjust based on the actual height of your top-bar */
  overflow-y: auto;
}

.chart {
  margin: 20px 0;
}

@media (min-width: 600px) {
  .chart {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

h1, h2, h3, h4, h5, h6 {
  color: #ddd;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,8BAA8B,EAAE,sDAAsD;EACtF,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;EACxB;AACF;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;AACb","sourcesContent":["/* src/App.css */\n.App {\n  text-align: center;\n}\n\n.top-bar {\n  position: fixed;\n  top: 0;\n  z-index: 1000;\n  width: 100%;\n  background-color: #282c34;\n  padding: 10px 20px;\n  color: white;\n  justify-content: start;\n  align-items: left;\n  display: flex;\n  gap: 10px;\n}\n\n.menu button {\n  margin-right: 20px;\n  background-color: #61dafb;\n  border: none;\n  padding: 10px 20px;\n  cursor: pointer;\n  font-size: 1rem;\n}\n\n.content {\n  background-color: #393e48;\n  padding: 80px;\n}\n\n.chart-container {\n  max-height: calc(100vh - 60px); /* Adjust based on the actual height of your top-bar */\n  overflow-y: auto;\n}\n\n.chart {\n  margin: 20px 0;\n}\n\n@media (min-width: 600px) {\n  .chart {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n  }\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\nh1, h2, h3, h4, h5, h6 {\n  color: #ddd;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
